// Catalog area — destinations (+ tab components), guides, destination teams,
// country knowledge base.
export const catalog = {
  continents: {
    asia: "Asia",
    africa: "Africa",
    southAmerica: "South America",
    northAmerica: "North America",
    oceania: "Oceania",
    europe: "Europe",
  },
  months: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dec",
  },
  confirmDeleteNamed: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  basicInfo: "Basic information",
  urlSlug: "URL slug",
  photo: "Photo",
  destinations: {
    list: {
      title: "Destinations",
      subtitle: "Manage trip destinations",
      new: "New destination",
      searchPlaceholder: "Search destinations...",
      allContinents: "All continents",
      loadError: "Error loading destinations. Please try again.",
      empty: "No destinations found",
      facetCountry: "Country",
      facetLevel: "Level",
      levelCountry: "Country",
      levelPlace: "Place",
      colContinent: "Continent",
      featured: "Featured",
      standard: "Standard",
      facetNav: "Destination menu",
      navShown: "In menu",
      navHidden: "Not in menu",
      navToggleTitle:
        "Toggle whether this destination is offered in the menu, the trip filter and the homepage search",
    },
    edit: {
      newTitle: "New destination",
      editTitle: "Edit destination",
      newSubtitle: "Create a new destination",
      editingSubtitle: "Editing: {{name}}",
      loadFailed: "Failed to load destination",
      unknownError: "Unknown error",
      backToList: "Back to destinations",
      tabs: {
        basic: "Basic",
        content: "Content",
        practical: "Practical info",
        cuisine: "Tips, activities and benefits",
        media: "Media",
        faq: "FAQ",
        offer: "Offer",
        related: "Related",
      },
    },
    featuredImage: "Featured image",
    basic: {
      namePlaceholder: "e.g. Vietnam",
      slugPlaceholder: "e.g. vietnam",
      continent: "Continent",
      parent: "Parent destination",
      parentNone: "None (top-level)",
      parentInfoText: "Country infobox text",
      parentInfoTextPlaceholder: "e.g. Hoi An lies in central Vietnam…",
      assignedGuide: "Assigned guide",
      noGuide: "No guide",
      assignedGuideHintLink: "Contacts & teams →",
      latitude: "Latitude (GPS)",
      longitude: "Longitude (GPS)",
      latRange: "Must be between -90 and 90",
      lngRange: "Must be between -180 and 180",
      latHint: "-90 to 90",
      lngHint: "-180 to 180",
      latPlaceholder: "e.g. 16.0544",
      lngPlaceholder: "e.g. 108.2022",
      heroPlaceholder: "e.g. Discover Vietnam",
      headingPlaceholder: "e.g. Vietnam – Discover the essence of Southeast Asia",
      shortDescriptionTitle: "Short description (for search engines and previews)",
      shortDescription: "Short description",
      shortDescriptionPlaceholder: "Vietnam – the essence of Asia...",
      climateTitle: "Climate and best time to visit",
      climate: "Climate",
      climatePlaceholder: "e.g. Tropical monsoon",
      bestTime: "Best time to visit",
      bestTimePlaceholder: "e.g. February - June",
      descriptionTitle: "Destination description",
      descriptionPlaceholder: "Detailed destination description...",
      seoTitle: "SEO",
      metaTitle: "Meta title",
      metaTitlePlaceholder: "SEO title",
      metaDescription: "Meta description",
      metaDescriptionPlaceholder: "Short description for search engines (max 160 characters)",
      defaultMinPax: "Default calculation pax",
      autoRouteLeads: "Auto-route leads",
      showAsFeatured: "Show as featured",
      showInNav: "Offer in menu and filters",
      showAsCountry: "Show as a country",
    },
    content: {
      testimonialTitle: "Testimonial quote",
      quote: "Quote",
      quotePlaceholder: "Customer testimonial quote...",
      author: "Author / Title",
      authorPlaceholder: "e.g. We know we've arranged everything perfectly",
      authorImage: "Author image",
      backgroundImage: "Background image",
      additionalTitle: "Additional content",
      additionalText: "Additional text",
      additionalTextPlaceholder: "Additional content about the destination...",
      additionalImage: "Additional image",
    },
    practical: {
      title: "Practical information",
      visa: "Visa",
      visaPlaceholder: "Visa information...",
      currencyPlaceholder: "e.g. Vietnamese Dong (VND)",
      language: "Language",
      languagePlaceholder: "e.g. Vietnamese",
      timezone: "Timezone",
      timezonePlaceholder: "e.g. UTC+7",
      electricity: "Electricity",
      electricityPlaceholder: "e.g. 220V, type A/C/G",
      vaccination: "Vaccination",
      vaccinationPlaceholder: "Recommended vaccinations...",
      weatherTitle: "Weather data (month grid)",
      cycleHint: "Click to cycle: off → best (green) → good (orange) → off",
      temperaturesTitle: "Temperatures per month",
      airTemp: "Air °C",
      waterTemp: "Water °C",
      tempLegend: "Left = Air °C, Right = Water °C",
      weatherDescription: "Weather description",
      weatherDescriptionPlaceholder: "Describe the overall climate and best times to visit...",
      localTip: "Local tip",
      localTipPlaceholder:
        "Short practical advice shown under Climate, e.g. plan sightseeing for the morning…",
      monthlyTitle: "Weather text per month",
      monthlyPlaceholder: "What's the weather like in {{month}}?",
    },
    cuisine: {
      gastronomyTitle: "Where to eat well (Useful tips)",
      description: "Tip text",
      descriptionPlaceholder: "Vietnamese cuisine is famous for its freshness...",
      activitiesTitle: "Activities",
      activitiesDescription: "Add activities you can experience at this destination",
      activitiesPlaceholder: "e.g. Cruise on Ha Long Bay",
      activitiesEmpty: "No activities yet",
      whyWithUsTitle: "Why travel with us",
      whyWithUsPlaceholder: "e.g. We have our own Czech-speaking guides in Hanoi.",
      whyWithUsTitlePlaceholder: "Card heading (optional)",
      whyWithUsIconLabel: "Pictogram",
      whyWithUsEmpty: "No benefits yet",
      whyWithUsIcons: {
        check: "Checkmark",
        guide: "Guide",
        group: "Group",
        briefcase: "Briefcase",
        map: "Map",
        heart: "Heart",
        star: "Star",
        shield: "Shield",
        support: "Phone",
        tip: "Lightbulb",
      },
    },
    media: {
      gallery: "Gallery",
      socialReels: "Social reels (Get Inspired section)",
      videoBlock: "Destination video",
      videoUrl: "Video URL (YouTube or Instagram)",
      videoUrlHint: "The video plays in an overlay on the page, only after cookie consent.",
      videoTitle: "Heading",
      titlePlaceholder: "e.g. VIETNAM SPECIAL: Tips from A to Z",
      videoDescription: "Description",
      videoDescriptionHint: "Keep it short; the full YouTube text does not belong here.",
      descriptionPlaceholder: "Short description for the video section…",
      thumbnail: "Thumbnail (16:9)",
      thumbnailHint: "Use a wide photo; a YouTube screenshot will blur.",
      moreVideosUrl: "Link to more videos",
      moreVideosUrlHint: "A full address starting with https://, e.g. a YouTube playlist.",
      moreVideosUrlInvalid: "Enter a full address starting with https:// (max. 500 characters).",
    },
    faq: {
      title: "Destination FAQ",
    },
    offer: {
      title: "Offer page content",
      hint: 'Intro text and FAQ for this destination\'s trip listing. Stored separately per surface — "All types" belongs to the address without a chosen type, the others to its type variants.',
      allTypes: "All types",
      introLabel: "Intro text",
      introPlaceholder: "e.g. We run guided tours of Japan with a Czech-speaking guide…",
      faqLabel: "FAQ",
      statusTitle: "Indexing status",
      statusLoading: "Loading trip counts…",
      statusFailed: "Failed to load trip counts.",
      statusNew: "Indexing status appears after the destination is saved for the first time.",
      tripCountLabel: "Trips in this combination",
      introCharsLabel: "Intro text length (characters)",
      verdictYes: "Will be indexed and listed in the sitemap",
      verdictNo: "Will not be indexed nor listed in the sitemap",
      missingLabel: "Missing:",
      reasonTrips: "too few trips: {{count}} of {{min}} required",
      reasonIntro: "intro text too short: {{count}} of {{min}} required characters",
      unpublished:
        "This destination is not published, so its offer address still returns 404 and the threshold does not apply — that is why the counts stay at zero. You can write the content up front.",
      planningTitle: "Planning block",
      planningVariantLabel: "Variant",
      planningDefault: "Default website text",
      planningVariantOption: "Variant {{n}}",
      planningPreviewLabel: "Preview",
      planningPreviewDefault: "The website will use the default wording.",
      planningPreviewEmpty:
        "Variant {{n}} has no text in Settings — the website will use the default wording.",
      planningPreviewFailed: "The variant texts could not be loaded.",
      planningOwnText: "Own text (overrides the variant)",
      planningOwnTextHint: "Plain text. Empty = the chosen variant applies.",
    },
    related: {
      tripsTitle: "Trips to this destination",
      tripsHint:
        "Trips that have this destination as their main one. The link is set on the trip itself (Destination field and destination tags), so this list is read-only.",
      tripsSearchPlaceholder: "Search trips...",
      tripsEmpty: "No trip points to this destination yet.",
      inspirationsTitle: "Inspirations in this destination",
      inspirationsPickerLabel: "Assigned inspirations",
      inspirationsSearchPlaceholder: "Search inspirations...",
      tripsLoadFailed: "Could not load trips.",
      inspirationsLoadFailed: "Could not load inspirations.",
    },
    highlights: {
      title: "Top attractions",
      subtitle: "Add the most interesting places and experiences at this destination",
      add: "Add attraction",
      empty: "No attractions yet",
      addFirst: "Add first attraction",
      itemFallback: "Attraction {{number}}",
      namePlaceholder: "e.g. Ha Long Bay",
      descriptionPlaceholder: "Short description of the attraction...",
    },
    regions: {
      title: "Regions",
      subtitle: "Add individual areas of the destination",
      add: "Add region",
      empty: "No regions yet",
      addFirst: "Add first region",
      itemFallback: "Region {{number}}",
      namePlaceholder: "e.g. Northern Vietnam",
      descriptionPlaceholder: "Detailed region description...",
    },
    stringArray: {
      placeholder: "Enter text...",
      empty: "No items yet",
      add: "Add item",
    },
  },
  guides: {
    list: {
      title: "Guides",
      subtitle: "Manage tour guides",
      new: "New guide",
      searchPlaceholder: "Search guides...",
      loadError: "Error loading guides. Please try again.",
      empty: "No guides found",
    },
    edit: {
      newTitle: "New guide",
      editTitle: "Edit guide",
      namePlaceholder: "e.g. John Smith",
      slugPlaceholder: "e.g. john-smith",
      yearsExperience: "Years of experience",
      location: "Location",
      locationPlaceholder: "Ho Chi Minh City, Vietnam",
      bioTitle: "Biography",
      bioLabel: "Bio",
      bioPlaceholder: "Short guide biography...",
      specializations: "Specializations",
      specializationsPlaceholder: "Asia, Trekking, Diving",
      specializationsHint: "Separate with commas",
      homeDestination: "Home destination",
      homeDestinationNone: "— none —",
      activeGuide: "Active guide",
    },
  },
  teams: {
    sections: {
      guarantor: "Guarantor",
      salesTeam: "Sales team",
      guide: "Guide",
      localTeam: "Local team",
      flightBooking: "Flight booking",
      management: "Management",
      branchManager: "Branch manager",
    },
    list: {
      title: "Destination contacts & teams",
      subtitle:
        "Name, role, phone and e-mail of the people shown to customers in the „Contact our specialists“ section on destinations, places, inspirations and trips.",
      new: "New team section",
      searchPlaceholder: "Search by name or destination...",
      allTypes: "All types",
      loadError: "Error loading destination teams. Please try again.",
      empty: "No team sections found",
      noDestination: "No destination — hidden on the website",
    },
    edit: {
      newTitle: "New team section",
      editTitle: "Edit team section",
      namePlaceholder: "e.g. John Smith",
      sectionType: "Section type",
      destinationsLabel: "Destinations this card appears on",
      destinationsSearch: "Search a country...",
      noDestinationHint:
        "With no destination selected the card appears on no page of the website — it stays here in the admin only.",
      primaryDestination: "Primary — phone from the Phone field: {{phone}}",
      phoneOverride: "Different phone for this destination",
      memberPhonePlaceholder: "Member phone (optional)",
      memberEmailPlaceholder: "Member e-mail (optional)",
      subtitleRole: "Subtitle / Role",
      subtitlePlaceholder: "e.g. Destination Guarantor for Vietnam",
      emailPlaceholder: "e.g. jana@ckgo2.cz",
      phonePlaceholder: "e.g. +420 793 950 220",
      bioTitle: "Biography / Description",
      bioPlaceholder: "Tell us about this person or team...",
      membersTitle: "Team members",
      addMember: "Add member",
      membersHint: "For team sections (Sales team, Local team), list individual team members.",
      membersEmpty: "No members added yet",
      rolePlaceholder: "Role (optional)",
      galleryTitle: "Photo gallery",
      uploadTeamPhotos: "Upload team photos",
      mainPhoto: "Main photo",
      sortOrderHint: "Lower = higher priority",
      activeVisible: "Active (visible on website)",
    },
  },
  countryKb: {
    list: {
      title: "Country KB",
      subtitle:
        "Visa, passport, arrival-card and seasonality facts — feeds offers, the pre-departure pack and the AI sales layer.",
      new: "New country",
      colCountry: "Country",
      colCode: "Code",
      colVisa: "Visa",
      colArrivalCard: "Arrival card",
      empty: "No countries yet.",
      visaPolicies: {
        visaFree: "Visa-free",
        onArrival: "On arrival",
        eVisa: "E-visa",
        embassy: "Embassy",
      },
    },
    edit: {
      newTitle: "New country",
      fallbackTitle: "Country",
      subtitle: "Structured facts — offers, pre-departure pack and the AI read these as data.",
      countryCode: "Country code (ISO-2)",
      twoLetters: "2 letters",
      countryName: "Country name",
      visaTitle: "Visa",
      policy: "Policy",
      unknown: "— Unknown —",
      policyVisaFree: "Visa-free",
      policyOnArrival: "Visa on arrival",
      policyEVisa: "E-visa",
      policyEmbassy: "Embassy visa",
      visaFreeDays: "Visa-free days",
      fee: "Fee",
      feePlaceholder: "25 USD (single-entry e-visa)",
      officialUrl: "Official URL",
      visaNotesPlaceholder: "Application steps, processing time, multi-entry rules…",
      passportHealthTitle: "Passport & health",
      passportMinValidity: "Passport min validity (months)",
      vaccination: "Vaccination",
      vaccinationPlaceholder: "None required; Hepatitis A/B recommended",
      healthNotes: "Health notes",
      arrivalCardTitle: "Arrival card",
      arrivalNone: "None",
      arrivalOnArrival: "Paper on arrival",
      arrivalOnline: "Online form",
      opensDaysBefore: "Opens (days before)",
      formUrl: "Form URL",
      entryEngineTitle: "Entry engine",
      entryEngineHint:
        "Drives the per-traveller filing queue on departures. Auto-filing stays off until the browser flow for this country is verified (Block 5.4 PoC).",
      groupSubmission: "Group submission (pax)",
      groupSubmissionHint: "TDAC/SGAC 10; per-pax portals 1",
      visaTaskOpens: "Visa task opens (days before)",
      visaTaskOpensHint: "e-visa lead time",
      filingChannel: "Filing channel",
      channelManual: "Manual (operator)",
      channelBrowser: "Browser (autopilot)",
      extraArtifacts: "Extra artifacts",
      commaSeparated: "comma-separated",
      autoFiling: "Auto-filing enabled (requires browser channel + client consent)",
      seasonalityTitle: "Seasonality",
      seasonalityHint:
        "Click a month to cycle best → good → poor → unset. The AI uses this to suggest a better month when an inquiry hits a poor season.",
      cycleTitle: "Click to cycle best → good → poor → unset",
      seasonNotePlaceholder: "why (e.g. dry season)",
      scoreBest: "best",
      scoreGood: "good",
      scorePoor: "poor",
      practicalTitle: "Practical",
      currencyPlaceholder: "VND; cards common in cities, cash elsewhere",
      plugs: "Plugs",
      tipping: "Tipping",
      tippingPlaceholder: "Not expected; guides ~5 USD/day appreciated",
      safetyNotes: "Safety notes",
      practicalNotes: "Practical notes",
      practicalNotesPlaceholder: "SIM cards, transport, dress code…",
    },
  },
};
